import gql from 'graphql-tag';

import { courseFragment } from '~/shared/graphql-queries/courses/index';

export default gql`
  query findManyCourseQuery(
    $limit: Int = 20
    $filter: FilterFindManyCourseInput
    $sort: SortFindManyCourseInput
  ) {
    findManyCourseQuery(filter: $filter, skip: 0, limit: $limit, sort: $sort) {
      ...CourseFragment
    }
  }
  ${courseFragment}
`;
